export const externalScholarshipFormFields = [
  {
    id: 1,
    sectionName: "External Scholarship Details",
    isGroupedSection: false,
    sectionFields: [
      {
        sectionId: 1,
        type: "text",
        key: "name",
        label: "External Scholarship Name",
        isRequired: true,
        hasOptions: false,
        disabled: false,
        placeholder: "Enter the external scholarship name",
        regexKey: "generalText",
      },
      {
        sectionId: 1,
        type: "text",
        key: "sponsor",
        label: "External Scholarship Sponsor",
        isRequired: true,
        hasOptions: false,
        disabled: false,
        placeholder: "Enter the external scholarship sponsor",
        regexKey: "generalText",
      },
      {
        sectionId: 1,
        type: "text",
        key: "url",
        label: "External Scholarship URL",
        isRequired: true,
        hasOptions: false,
        disabled: false,
        placeholder: "Enter the external scholarship url",
        regexKey: "generalText",
      },
      {
        sectionId: 2,
        type: "datetime-local",
        key: "deadline",
        label: "External Scholarship Deadline",
        isRequired: true,
        hasOptions: false,
        disabled: false,
        placeholder: "Set External Scholarship Deadline (MM/DD/YYYY)",
        regexKey: "generalText",
      },
    ],
  },
];
